import { type OpenApiSchemaYmlGoodsModerationStatus } from '#shared/api/schema';
import { PRODUCT_MODERATION_STATUS_LABEL_MAP } from './constants';

export function isAllowedProductModerationStatus(status: unknown): status is OpenApiSchemaYmlGoodsModerationStatus {
    return typeof status === 'string' && status in PRODUCT_MODERATION_STATUS_LABEL_MAP;
}
